import { render } from "./ReviewAndSign.vue?vue&type=template&id=4fe0f6cd&scoped=true"
import script from "./ReviewAndSign.vue?vue&type=script&lang=js"
export * from "./ReviewAndSign.vue?vue&type=script&lang=js"

import "./ReviewAndSign.vue?vue&type=style&index=0&id=4fe0f6cd&scoped=true&lang=scss"

import exportComponent from "/Users/rulez/Dropbox/Projects/SimpleW/rulez/onboarding2101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe0f6cd"]])

export default __exports__